import * as recommendedCartService from '/source/js/services/recommendedCartService';
import { loadSpinner, stopSpinner } from '/source/_patterns/01-components/spinner/spinner';

function changeShareImage(e) {
    if(e) {
        e.preventDefault();
    }
    let imageSelected = $('#shareImageModalSelectDropdown').val();
    $('.shareImageModal__image').attr('src', imageSelected);
}

function closeChangeShareImageModal(e) {
    if(e) {
        e.preventDefault();
    }
    let prevImage = $('.shareImageModal__selectionDropdown').attr('data-prevImage');
    $('.shareImageModal__image').attr('src', prevImage);
    $('#shareImageModalSelectDropdown').val(prevImage);
    $('#shareImageModal').modal('hide');
}

async function saveShareImage(e) {
    if(e) {
        e.preventDefault();
    }
    try {
        loadSpinner();
        let currentImage = $('#shareImageModalSelectDropdown').val();
        $('#shareImage').val(currentImage);
        let selectedSku = $('#shareImageModalSelectDropdown').find('option:selected').data('selected-sku');
        let result = await recommendedCartService.saveShareImageModal(currentImage, selectedSku);

        if(result.IsSuccessful) {
            $('#shareImageSku').val(selectedSku);
            $('.shareImageModal__image').attr('src', currentImage); // update the modal image
            $('.shareImageModal__selectionDropdown').attr('data-prevImage', currentImage); // set previous image to the current saved image
            // update the select dropdown when user goes to modal again after saving image
            let selectedOption = $('#shareImageModalSelectDropdown').find('option:selected').text();
            $('#shareImageModalSelectDropdown option').filter(function(index) {
                return $(this).text() === selectedOption;
            }).attr('selected', 'selected');
            $('.recommendedCart__image').attr('src', currentImage); // update high level summary image
        } else {
            console.log('Image was not able to be saved.');
        }
    } catch (ex) {
        console.log(ex);
    }
    stopSpinner();
    $('#shareImageModal').modal('hide');
}

function setImageModal() {
    let imgPath = $('#shareImage').val();
    $(`#shareImageModalSelectDropdown option[value="${imgPath}"]`).prop('selected', true).change();
    $('.recommendedCart__image').attr('src', imgPath);
    $('.shareImageModal__image').attr('src', imgPath);
    $('.shareImageModal__selectionDropdown').attr('data-prevImage', imgPath);
}

function initEventHandlers() {
    $('#shareImageModalSelectDropdown').on('change', changeShareImage);
    $('.shareImageModal__cancel-btn').on('click', closeChangeShareImageModal);
    $('#shareImageModalClose').on('click', closeChangeShareImageModal);
    $('#saveShareImage').on('click', saveShareImage);
}

$(function() {
    initEventHandlers();
    setImageModal();
});
